import { ApolloQueryResult } from 'apollo-client';
import { AuthenticationCode } from 'components/authentication/authentication-code';
import { AuthenticationModalType } from 'components/authentication/types';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IGenerateEmailVerificationCodeVariables, IVerifyEmailVerificationCodeVariables, MutationResponseByType, MutationType } from 'store/sagas/apiService/types';
import { RootAction, State } from 'store/state';
import { setInvestorsLoginStep } from 'store/state/app/actions';
import { authEmailSelector } from 'store/state/app/selectors';
import { inlineMutate } from 'store/state/mutationsResponse/actions';
import { verifyEmailVerificationCodeDataSelector, generateEmailVerificationCodeDataSelector } from 'store/state/mutationsResponse/selectors';

interface AuthCodeProps {
  email: string;
  setInvestorsStep: () => void;
  generateEmailVerificationCode: (data: IGenerateEmailVerificationCodeVariables) => void;
  verifyEmailVerificationCode: (data: IVerifyEmailVerificationCodeVariables) => void;
  verifyEmailVerificationCodeData: ApolloQueryResult<MutationResponseByType[MutationType.VerifyEmailVerificationCode]>;
  generateEmailVerificationCodeData: ApolloQueryResult<MutationResponseByType[MutationType.GenerateEmailVerificationCode]>;
}

const AuthCodeBase: React.FC<AuthCodeProps> = (props) => {
  const {
    email,
    setInvestorsStep,
    generateEmailVerificationCode,
    generateEmailVerificationCodeData,
    verifyEmailVerificationCode,
    verifyEmailVerificationCodeData,
  } = props;

  return (
    <AuthenticationCode
      email={email}
      setActiveModal={setInvestorsStep}
      isUser={false}
      generateEmailVerificationCode={generateEmailVerificationCode}
      generateEmailVerificationCodeData={generateEmailVerificationCodeData}
      verifyEmailVerificationCode={verifyEmailVerificationCode}
      verifyEmailVerificationCodeData={verifyEmailVerificationCodeData}
    />
  );
};

const mapStateToProps = (state: State) => ({
  email: authEmailSelector(state),
  verifyEmailVerificationCodeData: verifyEmailVerificationCodeDataSelector(state),
  generateEmailVerificationCodeData: generateEmailVerificationCodeDataSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  setInvestorsStep: () => dispatch(setInvestorsLoginStep({ type: AuthenticationModalType.SignUp }, { isUserInitiated: true })),
  generateEmailVerificationCode: (data: IGenerateEmailVerificationCodeVariables) => dispatch(inlineMutate(MutationType.GenerateEmailVerificationCode, data)),
  verifyEmailVerificationCode: (data: IVerifyEmailVerificationCodeVariables) => dispatch(inlineMutate(MutationType.VerifyEmailVerificationCode, data)),
});

export const AuthCode = connect(mapStateToProps, mapDispatchToProps)(AuthCodeBase);
